import dynamic from "next/dynamic";

const Component = dynamic(() => import("./_component"), {
	loading: () => <></>,
});
const Index = (props) => {
	return (
		<Component {...props}/>
	)
}
export default Index